import React from "react";
import { VStack } from "@chakra-ui/react";
import { addDays, format } from "date-fns";
import { PageHeader, Table, Wrapper } from "components";
import { useQueryParams } from "duck";
import { useGetEmailLogsQuery } from "requests";
import { Filter } from "./components";

const EmailLogs: React.FC = () => {
  const [{ pagination, filter }] = useQueryParams();

  const { data, loading } = useGetEmailLogsQuery({
    variables: {
      page: pagination?.page || 1,
      perPage: 15,
      filter: {
        ...((filter?.dateFrom || filter?.dateTo) && {
          range: {
            sentAt: {
              gte: filter?.dateFrom,
              lt: filter?.dateTo
                ? format(addDays(new Date(filter.dateTo), 1), "MM/dd/y")
                : null
            }
          }
        })
      }
    }
  });

  return (
    <VStack spacing={6} alignItems="left">
      <PageHeader title="Email Logs" />
      <Wrapper mt={6}>
        <VStack alignItems="left" spacing={7}>
          <Filter />
          <Table
            data={data?.emailLogs?.collection || []}
            loading={loading}
            totalCount={data?.emailLogs?.paginationInfo?.totalCount || 0}
            perPage={15}
            noDataMessage="No results found"
          >
            <Table.Column dataKey="recipientsUsername" label="Username" />
            <Table.Column dataKey="recipientsEmail" label="Email" />
            <Table.Column dataKey="emailSubject" label="Email Subject" />
            <Table.Column
              dataKey="sentAt"
              label="Date And Time"
              render={({ value }) =>
                format(new Date(value), "MM/dd/yyyy HH:mm")
              }
            />
          </Table>
        </VStack>
      </Wrapper>
    </VStack>
  );
};

export default EmailLogs;
